import { Link } from "react-router-dom";
import { ArrowRight, Phone, IndianRupee } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { waLink, poojaWaMessage } from "@/lib/whatsapp";
import { formatPrice, categoryLabel, resolveImg } from "@/lib/api";

const PoojaCard = ({ pooja, index = 0 }) => {
  const site = useSite();
  const img = resolveImg((pooja.images && pooja.images[0]) || "");
  return (
    <div
      className="reveal group flex flex-col bg-white border border-border rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_32px_-12px_rgba(107,26,34,0.18)]"
      style={{ animationDelay: `${index * 0.07}s` }}
      data-testid={`pooja-card-${pooja.slug}`}
    >
      <Link to={`/poojas/${pooja.slug}`} className="block relative h-48 overflow-hidden">
        <img src={img} alt={pooja.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <div className="pointer-events-none absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-black/45 to-transparent" />
        <span className="absolute top-3 left-3 inline-flex items-center rounded-full border border-[#D4AF37]/60 bg-black/55 backdrop-blur-sm px-2.5 py-0.5 text-xs font-semibold text-[#F5D77A] shadow-sm">
          {categoryLabel(pooja.category)}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-6">
        <Link to={`/poojas/${pooja.slug}`}>
          <h3 className="font-heading text-2xl text-secondary leading-tight hover:text-primary transition-colors">{pooja.name}</h3>
        </Link>
        <p className="mt-2 text-sm text-muted-foreground leading-relaxed line-clamp-3 flex-1">{pooja.short_purpose}</p>
        {pooja.suitable_for && (
          <p className="mt-3 text-xs text-muted-foreground"><span className="font-semibold text-secondary">Suitable for:</span> {pooja.suitable_for}</p>
        )}
        <div className="mt-4 flex items-center gap-1 text-secondary">
          <span className="text-xs text-muted-foreground mr-1">Starting from</span>
          <IndianRupee className="h-4 w-4" />
          <span className="text-xl font-semibold">{pooja.price ? pooja.price.toLocaleString("en-IN") : "—"}</span>
        </div>
        <div className="mt-5 flex items-center gap-2">
          <Link
            to={`/poojas/${pooja.slug}`}
            data-testid={`pooja-view-${pooja.slug}`}
            className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-md bg-primary px-4 py-2.5 text-sm font-semibold text-white hover:bg-[#CC5204] transition-colors"
          >
            View Details <ArrowRight className="h-4 w-4" />
          </Link>
          <a
            href={waLink(site.whatsapp_number, poojaWaMessage(pooja.name))}
            target="_blank"
            rel="nofollow noopener noreferrer"
            data-testid={`book-whatsapp-${pooja.slug}`}
            aria-label="Book on WhatsApp"
            className="inline-flex items-center justify-center rounded-md bg-whatsapp px-3 py-2.5 text-white hover:opacity-90 transition-opacity"
          >
            <Phone className="h-4 w-4" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default PoojaCard;
